@if(color){
<div class="flex flex-wrap gap-4 sm:items-center sm:justify-center">
  <span
    class="inline-flex items-center justify-center gap-1 rounded-full py-0.5 pl-2 pr-2.5 text-sm font-medium"
    [ngClass]="[
      bgColor,
      textColor,
      darkBgColor,
      darkTextColor,
    ]"
  >
    {{ text }}
  </span>
</div>
}
